import BundlePrice from './BundlePrice';

export default BundlePrice;
